:host([light]) {
    & .rain_cloud_st0 {
        fill: #bbdefb;
    }
    & .rain_cloud_st1 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_1_);
    }
    & .rain_cloud_st2 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #ffffff;
    }
    & .rain_cloud_st3 {
        fill: #1a4e85;
    }
    & .rain_cloud_st4 {
        fill: none;
        stroke: #1a4e85;
        stroke-width: 6;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    & .rain_cloud_st5 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000077321456999598265580000007866720827813754542_);
    }
    & .rain_cloud_st6 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000085220040164111920680000008768239060013633411_);
    }
    & .rain_cloud_st7 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000101089401577456282240000010390615197044376511_);
    }
    & .rain_cloud_st8 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000119100928034890248690000000464856888075058854_);
    }
    & .rain_cloud_st9 {
        fill: #ffffff;
    }
    & .rain_cloud_st10 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000124134787038507233930000002697554679897375121_);
    }
    & .rain_cloud_st11 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000026876887545568816420000009744179690612579202_);
    }
    & .rain_cloud_st12 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000134223303396868926390000016064321435700226189_);
    }
    & .rain_cloud_st13 {
        fill: none;
        stroke: #1a4e85;
        stroke-width: 6;
        stroke-miterlimit: 10;
    }
}
:host([dark]) {
    & .rain_cloud_st0 {
        display: none;
    }
    & .rain_cloud_st1 {
        display: inline;
        fill: #bbdefb;
    }
    & .rain_cloud_st2 {
        display: inline;
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_1_);
    }
    & .rain_cloud_st3 {
        display: inline;
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #ffffff;
    }
    & .rain_cloud_st4 {
        display: inline;
        fill: #1a4e85;
    }
    & .rain_cloud_st5 {
        display: inline;
        fill: none;
        stroke: #1a4e85;
        stroke-width: 6;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    & .rain_cloud_st6 {
        display: inline;
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000155116448821726729470000012383270914410879640_);
    }
    & .rain_cloud_st7 {
        display: inline;
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000041294425895834748910000015570218452020079037_);
    }
    & .rain_cloud_st8 {
        display: inline;
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000114064460874567735710000004532445987756874170_);
    }
    & .rain_cloud_st9 {
        display: inline;
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000034799636219009574870000003683048016701003698_);
    }
    & .rain_cloud_st10 {
        display: inline;
        fill: #ffffff;
    }
    & .rain_cloud_st11 {
        display: inline;
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000154389297688791093670000002730132615291804833_);
    }
    & .rain_cloud_st12 {
        display: inline;
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000178164812447890956590000000630303799691304082_);
    }
    & .rain_cloud_st13 {
        display: inline;
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000135649847112720418960000014533782726855151759_);
    }
    & .rain_cloud_st14 {
        display: inline;
        fill: none;
        stroke: #1a4e85;
        stroke-width: 6;
        stroke-miterlimit: 10;
    }
    & .rain_cloud_st15 {
        fill: #09264a;
    }
    & .rain_cloud_st16 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000061434043404693563590000015889141998920069809_);
    }
    & .rain_cloud_st17 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #ced4db;
    }
    & .rain_cloud_st18 {
        fill: none;
        stroke: #ffffff;
        stroke-width: 6;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    & .rain_cloud_st19 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000157286076580361468310000013046393891000233632_);
    }
    & .rain_cloud_st20 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000140730199860946577290000014601390904892408742_);
    }
    & .rain_cloud_st21 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000000191078015981817960000000465969110484169144_);
    }
    & .rain_cloud_st22 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000088819325581525457550000005228791263179549583_);
    }
    & .rain_cloud_st23 {
        fill: #ffffff;
    }
    & .rain_cloud_st24 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000152979479707758957160000016572162668508977087_);
    }
    & .rain_cloud_st25 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000077307769931485378710000001747467944206242949_);
    }
    & .rain_cloud_st26 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#rain_cloud_SVGID_00000073709806166423337180000006981133572720767919_);
    }
    & .rain_cloud_st27 {
        fill: none;
        stroke: #ffffff;
        stroke-width: 6;
        stroke-miterlimit: 10;
    }
}
